import { createFileRoute } from '@tanstack/react-router'
import { PurchaseOrderEditor } from '../-PurchaseOrderEditor'

export const Route = createFileRoute('/purchasing/orders/$id/')({
  component: () => {
    const { id } = Route.useParams()
    return <PurchaseOrderEditor id={id} />
  },
})
